import React, { useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
import { BrandMark } from './BrandMark';
const navLinks = [{
  href: '/',
  label: 'Home'
}, {
  href: '/pricing',
  label: 'Pricing'
}, {
  href: '/blog',
  label: 'Blog'
}];
export function LandingHeader() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  function closeMenu() {
    setIsMenuOpen(false);
  }
  return <header className="navy-texture border-b border-[#031849]" data-id="element-162" data-mp="2q2oj4y3fwsx3">
      <div className="mx-auto flex min-h-20 max-w-6xl items-center justify-between px-5 sm:px-8" data-id="element-163" data-mp="2q0tvvd4p4opu">
        <a href="/" className="rounded-lg outline-none focus:ring-2 focus:ring-[#4BE4FF] focus:ring-offset-4 focus:ring-offset-[#041F60]" aria-label="Credit Manager home" onClick={closeMenu} data-id="element-164" data-mp="2lz8og7axl2n1">
          <BrandMark inverse data-id="element-165" data-mp="39qe34j54xovr" />
        </a>
        <nav aria-label="Primary navigation" className="hidden items-center gap-7 md:flex" data-id="element-166" data-mp="39rfgwvdjcph6">
          {navLinks.map(link => <a key={link.href} href={link.href} className="text-sm font-semibold text-[#A6B6F8] transition hover:text-white focus:underline focus:underline-offset-4 focus:outline-none" data-id="element-167" data-mp="2hl4zlecmicsr">
              {link.label}
            </a>)}
          <a href="/signup" className="rounded-lg bg-[#4BE4FF] px-4 py-2.5 text-sm font-bold text-[#041F60] transition hover:bg-[#38d9f2] focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-[#041F60]" data-id="element-168" data-mp="2vknwtc3wc3qa">
            Start your free trial
          </a>
        </nav>
        <button type="button" onClick={() => setIsMenuOpen(current => !current)} aria-expanded={isMenuOpen} aria-controls="mobile-navigation" aria-label={isMenuOpen ? 'Close navigation menu' : 'Open navigation menu'} className="grid h-10 w-10 place-items-center rounded-lg text-white outline-none transition hover:bg-white/10 focus:ring-2 focus:ring-[#4BE4FF] focus:ring-offset-2 focus:ring-offset-[#041F60] md:hidden" data-id="element-169" data-mp="3a8iqovtn4e4y">
          {isMenuOpen ? <XIcon size={21} aria-hidden="true" data-id="element-170" data-mp="1j9ajp009xmlg" /> : <MenuIcon size={22} aria-hidden="true" data-id="element-171" data-mp="1xwnbh6gocoka" />}
        </button>
      </div>
      {isMenuOpen && <nav id="mobile-navigation" aria-label="Mobile navigation" className="border-t border-[#A6B6F8]/30 px-5 py-4 md:hidden" data-id="element-172" data-mp="1t4vgmjqhjwoc">
          <div className="mx-auto flex max-w-6xl flex-col gap-1" data-id="element-173" data-mp="22vzvzkk2pjjp">
            {navLinks.map(link => <a key={link.href} href={link.href} onClick={closeMenu} className="rounded-lg px-3 py-3 text-sm font-bold text-white outline-none transition hover:bg-white/10 focus:ring-2 focus:ring-[#4BE4FF]" data-id="element-174" data-mp="2gvhni7or7awr">
                {link.label}
              </a>)}
            <a href="/signup" onClick={closeMenu} className="mt-2 rounded-lg bg-[#4BE4FF] px-4 py-3 text-center text-sm font-bold text-[#041F60] outline-none transition hover:bg-[#38d9f2] focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-[#041F60]" data-id="element-175" data-mp="hk879ofvqnwh">
              New client registration
            </a>
          </div>
        </nav>}
    </header>;
}